import React from 'react';
import { connect } from 'react-redux';
import RackForm from './RackForm';
import privateView from '../../components/hocs/privateView';
import Analytics from "../../services/Analytics";

class RackCreate extends React.Component{
	componentDidMount(){
    const { email } = this.props.injectedProps;
    Analytics.recordPageView('rack_create', email, {
      url: window.location.href,
      location: this.props.location,
      match: this.props.match
    });
  }
  render(){
    return(
      <div className="animate fadeIn">
        <RackForm
          useCrop
          title="Create New Rack"
          {...this.props}
        />
      </div>
    )
  }
}

const mapStateToProps = ({auth: { isFetch, roles, isLogged, id, email } })=>({
  guardData: { isFetch, roles, isLogged, id, email }
})

const enhance = connect(mapStateToProps);

export default enhance(privateView(RackCreate));